import React from 'react';

const RocketSeatIcon: React.FC = (props) => {
	return (
		<svg
			width='1em'
			height='1em'
			viewBox='0 0 41 41'
			fill='none'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.114 25.417a5647.58 5647.58 0 00-4.091-2.522l-4.09-2.524a.115.115 0 00-.175.095c-.01.185-.022.455-.029.606a.36.36 0 00.054.208l.94 1.51a.673.673 0 01.079.522l-.663 2.577a.27.27 0 00.092.28c.342.273.765.575 1.274.889.51.314.969.556 1.366.738a.265.265 0 00.288-.044l1.967-1.773a.656.656 0 01.497-.167l1.758.154a.352.352 0 00.208-.046l.522-.303a.117.117 0 00.003-.2zM14.553 28.677a.652.652 0 00-.353-.477 14.907 14.907 0 01-1.056-.582c-.114-.07-.528-.327-1-.674a.652.652 0 00-.586-.096l-.114.036a2.468 2.468 0 00-1.623 1.693L7.8 35.907c-.068.245.227.424.413.253l5.595-5.147a2.467 2.467 0 00.764-2.217l-.02-.119zM33.49 6.299c.24-.32.096-.562-.012-.661a.867.867 0 00-.41-.178l-3.48-.53a.878.878 0 00-.84.35L26.85 7.868a.885.885 0 00.148 1.204c.024.021.031.058.014.086a.067.067 0 01-.067.031l-2.277-.347a.998.998 0 00-.955.398l-5.551 7.566a.235.235 0 01-.311.062l-5.344-3.245a.734.734 0 00-1.02.268c-.2.353-.058.806.288 1.016l.138.084c.069.042.105.12.094.2l-.163 1.08a.146.146 0 01-.22.105l-.782-.468a1.338 1.338 0 00-1.845.447 1.354 1.354 0 00.253 1.71c.015.014.153.121.189.143l.002.002 3.992 2.457c2.158 1.31 3.798.236 4.31-.15.455-.342.971-.72 1.833-.194a.978.978 0 001.009-.003l.993-.592a.922.922 0 01.95.004l3.028 1.838a.268.268 0 00.355-.07l7.399-10.07c.603-.808.156-1.202-.211-1.298-.024-.006-.047-.012-.071-.016l-1.775-.27a.216.216 0 01-.076-.03.211.211 0 01-.07-.29L33.49 6.3z'

			/>
		</svg>
	);
};

export default RocketSeatIcon;
